module.exports = __webpack_public_path__ + "static/media/3D打印月球灯.9c64eb7d.png";